import { MetadataDistributionModel_Init, FrequencyListsModel_get_Default, ResultTab, Corpus__get_MetadataDistributionCategories, ConcordanceModel__NumResultPages_Z524259A4, Corpus__get_MetadataQuickView, Corpus__get_SharedInfo, Corpus__get_MetadataMenu } from "../Model/Model.js";
import { sumBy as sumBy_1, item, indexed, append as append_2, contains, empty as empty_1, cons, singleton as singleton_1, ofArray, isEmpty } from "../../fable_modules/fable-library.3.7.9/List.js";
import { createElement } from "react";
import { int32ToString, structuralHash, comparePrimitives, stringHash, safeHash, equals, createObj } from "../../fable_modules/fable-library.3.7.9/Util.js";
import { Helpers_extractClasses, Helpers_combineClasses } from "../../fable_modules/Feliz.Bulma.2.18.0/ElementBuilders.fs.js";
import { LoadedCorpus_ShowingResults_Msg, LoadedCorpus_ShowingResults_MetadataDistribution_Msg, LoadedCorpus_ShowingResults_FrequencyLists_Msg, LoadedCorpus_ShowingResults_Concordance_Msg, LoadedCorpus_Msg } from "../Update.js";
import { Interop_reactApi } from "../../fable_modules/Feliz.1.64.0/Interop.fs.js";
import { view as view_1 } from "../SearchViews/Fcs/View.js";
import { view as view_2 } from "../SearchViews/Cwb/View.js";
import { useFeliz_React__React_useState_Static_1505, useReact_useInputRef, useReact_useEffect_Z101E1A95, useReact_useElementRef } from "../../fable_modules/Feliz.1.64.0/React.fs.js";
import { toArray as toArray_1, collect, map, empty, singleton, append, delay, toList, iterate } from "../../fable_modules/fable-library.3.7.9/Seq.js";
import { map as map_2, defaultArg, value as value_190, some, toArray } from "../../fable_modules/fable-library.3.7.9/Option.js";
import { PropHelpers_createOnKey } from "../../fable_modules/Feliz.1.64.0/Properties.fs.js";
import { key_enter } from "../../fable_modules/Feliz.1.64.0/Key.fs.js";
import { spinnerOverlay, iconButton } from "../Common.js";
import { toString as toString_1, op_Addition, fromInt, fromBits, fromInteger, compare } from "../../fable_modules/fable-library.3.7.9/Long.js";
import { parse, tryParse } from "../../fable_modules/fable-library.3.7.9/Int32.js";
import { toString, FSharpRef } from "../../fable_modules/fable-library.3.7.9/Types.js";
import { SortKey_OfString_Z721C83C5, SharedCorpusInfo__HasAttribute_Z721C83C5, DownloadFormat, Metadata_Category__get_Name, CorpusModality, SharedCorpusInfo__GetDefaultAttribute } from "../../Shared/Shared.js";
import { interpolate, toText, join } from "../../fable_modules/fable-library.3.7.9/String.js";
import { FSharpMap__Change, tryFindKey, FSharpMap__get_Item, toArray as toArray_2, ofArray as ofArray_1, FSharpMap__get_Values, FSharpMap__get_Keys, empty as empty_2, FSharpMap__TryFind, FSharpMap__get_Count } from "../../fable_modules/fable-library.3.7.9/Map.js";
import { concordanceTable } from "./ResultViews/Cwb/Written.js";
import { concordanceTable as concordanceTable_1 } from "./ResultViews/Cwb/Spoken.js";
import { Array_groupBy, Array_distinct } from "../../fable_modules/fable-library.3.7.9/Seq2.js";
import { concat, sortBy, reverse, sumBy, append as append_1, collect as collect_1, map as map_1 } from "../../fable_modules/fable-library.3.7.9/Array.js";
import { FSharpSet__get_IsEmpty, FSharpSet__Add, singleton as singleton_2, FSharpSet__Remove, contains as contains_1, FSharpSet__Contains, ofSeq } from "../../fable_modules/fable-library.3.7.9/Set.js";
import result_map from "../../../react_components/result_map.jsx";
import { Msg } from "../Metadata/Update.js";
import { MetadataMenu_view } from "../Metadata/View.js";

export function shouldShowMetadataMenu(model) {
    if (isEmpty(Corpus__get_MetadataMenu(model.Corpus))) {
        return false;
    }
    else {
        const matchValue = model.ShouldShowMetadataMenu;
        if (matchValue == null) {
            if (model.Substate.tag === 1) {
                return !model.IsNarrowWindow;
            }
            else {
                return true;
            }
        }
        else {
            return matchValue;
        }
    }
}

export function topRowButtons(model, dispatch) {
    const elms = ofArray([shouldShowMetadataMenu(model) ? createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", (_arg1) => {
        dispatch(new LoadedCorpus_Msg(2, false));
    }], ["children", "Hide filters"]])))) : ((!isEmpty(Corpus__get_MetadataMenu(model.Corpus))) ? createElement("button", createObj(Helpers_combineClasses("button", ofArray([["onClick", (_arg2) => {
        dispatch(new LoadedCorpus_Msg(2, true));
    }], ["children", "Filters"]])))) : null), createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-info"], ["onClick", (_arg3) => {
        dispatch(new LoadedCorpus_Msg(22));
    }], ["children", "Reset form"]]))))]);
    return createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    });
}

export function selectSearchView(corpus, search, dispatch) {
    const matchValue = Corpus__get_SharedInfo(corpus).SearchEngine;
    if (matchValue.tag === 1) {
        return view_1(corpus, search, dispatch);
    }
    else {
        return view_2(corpus, search, dispatch);
    }
}

export function MetadataQuickView(metadataQuickViewInputProps) {
    const dispatch = metadataQuickViewInputProps.dispatch;
    const model = metadataQuickViewInputProps.model;
    const elementRef = useReact_useElementRef();
    useReact_useEffect_Z101E1A95(() => {
        iterate((quickViewElement) => {
            if (model.ShouldShowQuickView) {
                quickViewElement.focus();
            }
        }, toArray(elementRef.current));
    }, [model]);
    const props_12 = toList(delay(() => append(model.ShouldShowQuickView ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["style", {
        zIndex: 50,
    }]), delay(() => append(singleton(["ref", elementRef]), delay(() => append(singleton(["tabIndex", 0]), delay(() => append(singleton(["onKeyUp", (e) => {
        if (e.key === "Escape") {
            dispatch(new LoadedCorpus_Msg(24));
        }
    }]), delay(() => {
        let elems_4, elms, properties_1, elms_2, elms_1, props_8, elems_1, children_3;
        return singleton((elems_4 = [(elms = ofArray([createElement("div", createObj(ofArray([(properties_1 = ofArray([["fontSize", 16 + "px"], ["fontWeight", "bold"]]), ["style", createObj(properties_1)]), ["children", "Metadata"]]))), createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg1) => {
            dispatch(new LoadedCorpus_Msg(24));
        }]))))]), createElement("header", {
            className: "quickview-header",
            children: Interop_reactApi.Children.toArray(Array.from(elms)),
        })), (elms_2 = singleton_1((elms_1 = singleton_1((props_8 = ofArray([["style", {
            margin: 5,
        }], (elems_1 = [(children_3 = toList(delay(() => map((category) => {
            let value_19;
            const children_1 = ofArray([(value_19 = (category.Name + ":"), createElement("td", {
                children: [value_19],
            })), createElement("td", {
                dangerouslySetInnerHTML: {
                    __html: category.Value,
                },
            })]);
            return createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children_1)),
            });
        }, model.QuickViewMetadata))), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_3)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]), createElement("table", createObj(Helpers_combineClasses("table", props_8))))), createElement("div", {
            className: "quickview-block",
            children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
        }))), createElement("div", {
            className: "quickview-body",
            children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))]));
    }))))))))))));
    return createElement("div", createObj(Helpers_combineClasses("quickview", props_12)));
}

export function CorpusStartView_corpusNameBox(config) {
    let elems_3, elm_1, elms, props_2;
    let logo_1;
    const matchValue = config.Logo;
    if (matchValue == null) {
        logo_1 = null;
    }
    else {
        const logo = matchValue;
        logo_1 = createElement("img", {
            src: `corpora/${config.Code}/${logo}`,
        });
    }
    const props_7 = ofArray([["style", {
        padding: 20,
    }], (elems_3 = [(elm_1 = [(elms = ofArray([(props_2 = ofArray([["style", {
        minWidth: 394,
        justifyContent: "flex-start",
    }], ["children", createElement("h1", {
        className: "title",
        children: config.Name,
    })]]), createElement("div", createObj(Helpers_combineClasses("level-item", props_2)))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray([logo_1]),
    })]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))], createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_1)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]);
    return createElement("div", createObj(Helpers_combineClasses("box", props_7)));
}

export function CorpusStartView_corpusInfo(config) {
    const matchValue = config.Info;
    if (matchValue == null) {
        return null;
    }
    else {
        const info = matchValue;
        return createElement("div", {
            className: "corpus-info",
            style: {
                marginTop: 30,
                marginBottom: 10,
            },
            dangerouslySetInnerHTML: {
                __html: info,
            },
        });
    }
}

export function CorpusStartView_view(corpus, search, topRowButtonsElement, dispatch) {
    const children = ofArray([topRowButtonsElement, CorpusStartView_corpusNameBox(Corpus__get_SharedInfo(corpus)), selectSearchView(corpus, search, dispatch), CorpusStartView_corpusInfo(Corpus__get_SharedInfo(corpus))]);
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function ResultsView_Concordance_PaginationTextInput(resultsView_Concordance_PaginationTextInputInputProps) {
    const dispatch = resultsView_Concordance_PaginationTextInputInputProps.dispatch;
    const isDisabled = resultsView_Concordance_PaginationTextInputInputProps.isDisabled;
    const textValue = resultsView_Concordance_PaginationTextInputInputProps.textValue;
    const inputRef = useReact_useInputRef();
    const props = ofArray([["className", "is-small"], ["ref", inputRef], ["disabled", isDisabled], ["style", {
        width: 60,
        textAlign: "right",
    }], ["value", textValue], ["onClick", (_arg1) => {
        iterate((inputElement) => {
            inputElement.select();
        }, toArray(inputRef.current));
    }], ["onChange", (ev) => {
        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(5, ev.target.value));
    }], ["onKeyUp", (ev_1) => {
        PropHelpers_createOnKey(key_enter, (_arg2) => {
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(6, void 0, void 0));
        }, ev_1);
    }]]);
    return createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props))));
}

export function ResultsView_Concordance_pagination(loadedCorpusModel, concordanceModel, isSearchingOrFetching, numPages, dispatch) {
    let elms_1, elms, elms_2, elms_4, elms_3;
    const setPage = (e, pageNo) => {
        e.preventDefault();
        if (((!isSearchingOrFetching) && (pageNo >= 1)) && (pageNo <= numPages)) {
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(6, pageNo, void 0));
        }
    };
    const matchValue = concordanceModel.NumResults;
    let pattern_matching_result;
    if (matchValue != null) {
        if (compare(matchValue, fromInteger(loadedCorpusModel.Search.Params.PageSize, false, 2)) > 0) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return ofArray([(elms_1 = singleton_1((elms = ofArray([iconButton("fa-angle-double-left", (concordanceModel.PaginatorPageNo === 1) ? true : isSearchingOrFetching, (e_1) => {
                setPage(e_1, 1);
            }), iconButton("fa-angle-left", (concordanceModel.PaginatorPageNo === 1) ? true : isSearchingOrFetching, (e_2) => {
                setPage(e_2, concordanceModel.PaginatorPageNo - 1);
            })]), createElement("div", {
                className: "buttons",
                children: Interop_reactApi.Children.toArray(Array.from(elms)),
            }))), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
            })), (elms_2 = singleton_1(createElement(ResultsView_Concordance_PaginationTextInput, {
                textValue: concordanceModel.PaginatorTextValue,
                isDisabled: isSearchingOrFetching,
                dispatch: dispatch,
            })), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
            })), (elms_4 = singleton_1((elms_3 = ofArray([iconButton("fa-angle-right", (concordanceModel.PaginatorPageNo === numPages) ? true : isSearchingOrFetching, (e_3) => {
                setPage(e_3, concordanceModel.PaginatorPageNo + 1);
            }), iconButton("fa-angle-double-right", (concordanceModel.PaginatorPageNo === numPages) ? true : isSearchingOrFetching, (e_4) => {
                setPage(e_4, numPages);
            })]), createElement("div", {
                className: "buttons",
                children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
            }))), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
            }))]);
        }
        case 1: {
            return empty_1();
        }
    }
}

export function ResultsView_Concordance_ContextSizeTextInput(resultsView_Concordance_ContextSizeTextInputInputProps) {
    const dispatch = resultsView_Concordance_ContextSizeTextInputInputProps.dispatch;
    const isDisabled = resultsView_Concordance_ContextSizeTextInputInputProps.isDisabled;
    const textValue = resultsView_Concordance_ContextSizeTextInputInputProps.textValue;
    const inputRef = useReact_useInputRef();
    const props = ofArray([["className", "is-small"], ["ref", inputRef], ["disabled", isDisabled], ["style", {
        width: 40,
        textAlign: "right",
    }], ["value", textValue], ["onClick", (_arg1) => {
        iterate((inputElement) => {
            inputElement.select();
        }, toArray(inputRef.current));
    }], ["onChange", (ev) => {
        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(7, ev.target.value));
    }], ["onKeyUp", (ev_1) => {
        PropHelpers_createOnKey(key_enter, (_arg2) => {
            let matchValue;
            let outArg = 0;
            matchValue = [tryParse(textValue, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                outArg = (v | 0);
            })), outArg];
            if (matchValue[0]) {
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(8, matchValue[1]));
            }
        }, ev_1);
    }]]);
    return createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props))));
}

export function ResultsView_Concordance_DownloadWindow(resultsView_Concordance_DownloadWindowInputProps) {
    let elm_5, elms_2, props_38, elems_15, elms_3, elms_4, props_45, elems_18, elms_5, elms_6;
    const dispatch = resultsView_Concordance_DownloadWindowInputProps.dispatch;
    const corpus = resultsView_Concordance_DownloadWindowInputProps.corpus;
    const model = resultsView_Concordance_DownloadWindowInputProps.model;
    const elementRef = useReact_useElementRef();
    useReact_useEffect_Z101E1A95(() => {
        iterate((downloadWindowElement) => {
            if (model.ShouldShowDownloadWindow) {
                downloadWindowElement.focus();
            }
        }, toArray(elementRef.current));
    }, [model]);
    let attributeCheckboxes;
    const matchValue = Corpus__get_SharedInfo(corpus).LanguageConfig;
    if (matchValue.tag === 1) {
        throw (new Error("NOT IMPLEMENTED"));
    }
    else {
        const maybeAttrs = matchValue.fields[0];
        if (maybeAttrs == null) {
            attributeCheckboxes = null;
        }
        else {
            const attrs = maybeAttrs;
            const checkboxes = toList(delay(() => map((attr) => {
                let attribute, isChecked, elems, s;
                const elms = singleton_1((attribute = attr, (isChecked = contains(attr, model.DownloadAttributes, {
                    Equals: equals,
                    GetHashCode: safeHash,
                }), createElement("label", createObj(ofArray([["style", {
                    marginRight: 15,
                }], (elems = [createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", isChecked], ["onChange", (ev) => {
                    const _arg1 = ev.target.checked;
                    dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(14, attribute));
                }]]))))), (s = (` ${attribute.Name}`), createElement("span", {
                    className: "",
                    children: s,
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))))));
                return createElement("div", {
                    className: "control",
                    children: Interop_reactApi.Children.toArray(Array.from(elms)),
                });
            }, cons(SharedCorpusInfo__GetDefaultAttribute(Corpus__get_SharedInfo(corpus)), attrs))));
            const props_9 = ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], ["children", Interop_reactApi.Children.toArray(Array.from(checkboxes))]]);
            attributeCheckboxes = createElement("div", createObj(Helpers_combineClasses("field", props_9)));
        }
    }
    let metadataCheckboxes;
    if (!isEmpty(Corpus__get_MetadataQuickView(corpus))) {
        const checkboxes_1 = toList(delay(() => collect((category_1) => {
            let elms_1, category, isChecked_1, elems_1, s_1;
            return ((category_1["Shared.Metadata.Category.get_Code"]() !== "tid") ? true : (!equals(Corpus__get_SharedInfo(corpus).Modality, new CorpusModality(0)))) ? singleton((elms_1 = singleton_1((category = category_1, (isChecked_1 = contains(category_1, model.DownLoadCategories, {
                Equals: equals,
                GetHashCode: safeHash,
            }), createElement("label", createObj(ofArray([["style", {
                marginRight: 15,
            }], (elems_1 = [createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", isChecked_1], ["onChange", (ev_1) => {
                const _arg2 = ev_1.target.checked;
                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(15, category));
            }]]))))), (s_1 = (` ${Metadata_Category__get_Name(category)}`), createElement("span", {
                className: "",
                children: s_1,
            }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))))), createElement("div", {
                className: "control",
                children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
            }))) : empty();
        }, Corpus__get_MetadataQuickView(corpus))));
        const props_12 = ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], ["children", Interop_reactApi.Children.toArray(Array.from(checkboxes_1))]]);
        metadataCheckboxes = createElement("div", createObj(Helpers_combineClasses("field", props_12)));
    }
    else {
        metadataCheckboxes = null;
    }
    let modalFooter;
    const disableDownload = isEmpty(model.DownloadAttributes);
    modalFooter = singleton_1((elm_5 = [(elms_2 = toList(delay(() => {
        let children_4, children_2;
        return append(singleton((children_4 = singleton_1((children_2 = ofArray([createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", model.HeadersInDownload], ["onChange", (ev_2) => {
            const _arg3 = ev_2.target.checked;
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(16));
        }]]))))), createElement("span", {
            className: "",
            children: " Create headers",
        })]), createElement("label", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        }))), createElement("div", {
            className: "level-item",
            children: Interop_reactApi.Children.toArray(Array.from(children_4)),
        }))), delay(() => {
            let children_6, props_19;
            return append(singleton((children_6 = singleton_1((props_19 = toList(delay(() => append(singleton(["className", "is-success"]), delay(() => {
                let matchValue_1;
                return append((matchValue_1 = model.DownloadingFormat, (matchValue_1 == null) ? singleton(["disabled", disableDownload]) : ((matchValue_1.tag === 1) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => append(singleton(["onClick", (_arg4) => {
                    dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(17, new DownloadFormat(1)));
                }]), delay(() => append(singleton(["style", {
                    marginLeft: 5,
                }]), delay(() => singleton(["children", "Excel"])))))));
            })))), createElement("button", createObj(Helpers_combineClasses("button", props_19))))), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray(Array.from(children_6)),
            }))), delay(() => {
                let children_8, props_22;
                return append(singleton((children_8 = singleton_1((props_22 = toList(delay(() => append(singleton(["className", "is-success"]), delay(() => {
                    let matchValue_2;
                    return append((matchValue_2 = model.DownloadingFormat, (matchValue_2 == null) ? singleton(["disabled", disableDownload]) : ((matchValue_2.tag === 3) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => append(singleton(["onClick", (_arg5) => {
                        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(17, new DownloadFormat(3)));
                    }]), delay(() => singleton(["children", "Tab-separated"])))));
                })))), createElement("button", createObj(Helpers_combineClasses("button", props_22))))), createElement("div", {
                    className: "level-item",
                    children: Interop_reactApi.Children.toArray(Array.from(children_8)),
                }))), delay(() => {
                    let children_10, props_25;
                    return append(singleton((children_10 = singleton_1((props_25 = toList(delay(() => append(singleton(["className", "is-success"]), delay(() => {
                        let matchValue_3;
                        return append((matchValue_3 = model.DownloadingFormat, (matchValue_3 == null) ? singleton(["disabled", disableDownload]) : ((matchValue_3.tag === 2) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => append(singleton(["onClick", (_arg6) => {
                            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(17, new DownloadFormat(2)));
                        }]), delay(() => singleton(["children", "Comma-separated"])))));
                    })))), createElement("button", createObj(Helpers_combineClasses("button", props_25))))), createElement("div", {
                        className: "level-item",
                        children: Interop_reactApi.Children.toArray(Array.from(children_10)),
                    }))), delay(() => {
                        let children_12, props_28;
                        return (SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "phon") ? true : SharedCorpusInfo__HasAttribute_Z721C83C5(Corpus__get_SharedInfo(corpus), "orig")) ? singleton((children_12 = singleton_1((props_28 = toList(delay(() => append(singleton(["className", "is-success"]), delay(() => {
                            let matchValue_4;
                            return append((matchValue_4 = model.DownloadingFormat, (matchValue_4 == null) ? singleton(["disabled", false]) : ((matchValue_4.tag === 0) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => append(singleton(["onClick", (_arg7) => {
                                dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(17, new DownloadFormat(0)));
                            }]), delay(() => singleton(["children", "Multiline"])))));
                        })))), createElement("button", createObj(Helpers_combineClasses("button", props_28))))), createElement("div", {
                            className: "level-item",
                            children: Interop_reactApi.Children.toArray(Array.from(children_12)),
                        }))) : empty();
                    }));
                }));
            }));
        }));
    })), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    }))], createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_5)),
    })));
    let modalCardBody;
    const children_20 = ofArray([(props_38 = ofArray([["className", "is-info"], (elems_15 = [(elms_3 = singleton_1(createElement("p", {
        children: ["Attributes"],
    })), createElement("div", {
        className: "message-header",
        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
    })), (elms_4 = singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], ["children", attributeCheckboxes]]))))), createElement("div", {
        className: "message-body",
        children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_15))])]), createElement("article", createObj(Helpers_combineClasses("message", props_38)))), (props_45 = ofArray([["className", "is-info"], (elems_18 = [(elms_5 = singleton_1(createElement("p", {
        children: ["Metadata categories"],
    })), createElement("div", {
        className: "message-header",
        children: Interop_reactApi.Children.toArray(Array.from(elms_5)),
    })), (elms_6 = singleton_1(createElement("div", createObj(Helpers_combineClasses("field", ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], ["children", metadataCheckboxes]]))))), createElement("div", {
        className: "message-body",
        children: Interop_reactApi.Children.toArray(Array.from(elms_6)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_18))])]), createElement("article", createObj(Helpers_combineClasses("message", props_45))))]);
    modalCardBody = createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_20)),
    });
    const props_57 = toList(delay(() => append(model.ShouldShowDownloadWindow ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["ref", elementRef]), delay(() => append(singleton(["tabIndex", 0]), delay(() => append(singleton(["onKeyUp", (e) => {
        if (e.key === "Escape") {
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(13));
        }
    }]), delay(() => {
        let elems_23, elms_9, elms_7;
        return singleton((elems_23 = [createElement("div", createObj(Helpers_combineClasses("modal-background", singleton_1(["onClick", (_arg8) => {
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(13));
        }])))), (elms_9 = ofArray([(elms_7 = ofArray([createElement("p", {
            className: "modal-card-title",
            children: "Download results",
        }), createElement("button", createObj(Helpers_combineClasses("delete", singleton_1(["onClick", (_arg9) => {
            dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(13));
        }]))))]), createElement("header", {
            className: "modal-card-head",
            children: Interop_reactApi.Children.toArray(Array.from(elms_7)),
        })), createElement("section", {
            className: "modal-card-body",
            children: Interop_reactApi.Children.toArray([modalCardBody]),
        }), createElement("footer", {
            className: "modal-card-foot",
            children: Interop_reactApi.Children.toArray(Array.from(modalFooter)),
        })]), createElement("div", {
            className: "modal-card",
            children: Interop_reactApi.Children.toArray(Array.from(elms_9)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_23))]));
    }))))))))));
    return createElement("div", createObj(Helpers_combineClasses("modal", props_57)));
}

export function ResultsView_Concordance_view(loadedCorpusModel, concordanceModel, corpus, loadedCorpusDispatch, dispatch) {
    let elems, elems_1, elms, props_15;
    const numPages = ConcordanceModel__NumResultPages_Z524259A4(concordanceModel, loadedCorpusModel.Search.Params.PageSize) | 0;
    const isSearchingOrFetching = (concordanceModel.PagesBeingFetched.length > 0) ? true : concordanceModel.IsSearching;
    let sortMenu;
    const patternInput = Helpers_extractClasses(ofArray([["disabled", isSearchingOrFetching], ["value", toString(loadedCorpusModel.Search.Params.SortKey)], ["onChange", (ev) => {
        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(6, 1, SortKey_OfString_Z721C83C5(ev.target.value)));
    }], (elems = [createElement("option", {
        value: "Position",
        children: "Sort by position",
    }), createElement("option", {
        value: "Match",
        children: "Sort by match",
    }), createElement("option", {
        value: "Left",
        children: "Sort by left context",
    }), createElement("option", {
        value: "Right",
        children: "Sort by right context",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]));
    sortMenu = createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
    let downloadButton;
    const props_7 = ofArray([["disabled", isSearchingOrFetching], ["style", {
        marginLeft: 5,
    }], ["onClick", (_arg1) => {
        dispatch(new LoadedCorpus_ShowingResults_Concordance_Msg(12));
    }], ["children", "Download"]]);
    downloadButton = createElement("button", createObj(Helpers_combineClasses("button", props_7)));
    let resultsInfo;
    let text;
    const matchValue = concordanceModel.NumResults;
    if (matchValue == null) {
        text = (concordanceModel.IsSearching ? "Searching..." : "");
    }
    else {
        const numResults = matchValue;
        if (compare(numResults, fromBits(0, 0, false)) > 0) {
            const pagesStr = (numPages === 1) ? "page" : "pages";
            text = (concordanceModel.IsSearching ? (`Showing ${numResults} matches (${numPages} ${pagesStr}); searching...`) : (`Found ${numResults} matches (${numPages} pages)`));
        }
        else {
            text = "No matches found";
        }
    }
    const shouldShowSpinner = concordanceModel.IsSearching && (FSharpMap__get_Count(concordanceModel.ResultPages) > 0);
    const children = ofArray([createElement("div", {
        style: {
            width: 400,
            textAlign: "right",
            color: "#555",
        },
        children: text,
    }), createElement("div", {
        style: {
            position: "absolute",
            top: 10,
            left: 350,
        },
        children: spinnerOverlay(shouldShowSpinner, ofArray([["width", 40], ["height", 40]]), empty_1()),
    })]);
    resultsInfo = createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    const contextSelector = ofArray([createElement("div", createObj(Helpers_combineClasses("level-item", singleton_1(["children", "Context:"])))), (elms = singleton_1(createElement(ResultsView_Concordance_ContextSizeTextInput, {
        textValue: concordanceModel.ContextSizeTextValue,
        isDisabled: isSearchingOrFetching,
        dispatch: dispatch,
    })), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), (props_15 = ofArray([["style", {
        marginRight: 50,
    }], ["children", "words"]]), createElement("div", createObj(Helpers_combineClasses("level-item", props_15))))]);
    const resultPage = FSharpMap__TryFind(concordanceModel.ResultPages, concordanceModel.ResultPageNo);
    return toList(delay(() => append(singleton(createElement(ResultsView_Concordance_DownloadWindow, {
        model: concordanceModel,
        corpus: corpus,
        dispatch: dispatch,
    })), delay(() => {
        let elm_1, elms_2, elms_3;
        return append(singleton((elm_1 = [(elms_2 = ofArray([createElement("div", {
            className: "level-item",
            children: Interop_reactApi.Children.toArray([sortMenu, downloadButton]),
        }), createElement("div", {
            className: "level-item",
            children: Interop_reactApi.Children.toArray([resultsInfo]),
        })]), createElement("div", {
            className: "level-left",
            children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
        })), (elms_3 = toList(delay(() => append((!equals(Corpus__get_SharedInfo(corpus).Modality, new CorpusModality(0))) ? contextSelector : empty(), delay(() => ResultsView_Concordance_pagination(loadedCorpusModel, concordanceModel, isSearchingOrFetching, numPages, dispatch))))), createElement("div", {
            className: "level-right",
            children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
        }))], createElement("nav", {
            className: "level",
            children: Interop_reactApi.Children.toArray(Array.from(elm_1)),
        }))), delay(() => {
            let matchValue_1;
            return append((matchValue_1 = Corpus__get_SharedInfo(corpus).Modality, (matchValue_1.tag === 1) ? singleton(concordanceTable(concordanceModel, corpus, resultPage, loadedCorpusDispatch, dispatch)) : singleton(concordanceTable_1(concordanceModel, corpus, resultPage, loadedCorpusDispatch, dispatch))), delay(() => {
                let props_25, elems_9, elms_4;
                return singleton((props_25 = ofArray([["style", {
                    marginTop: 10,
                }], (elems_9 = [createElement("div", createObj(Helpers_combineClasses("level-left", empty_1()))), (elms_4 = ResultsView_Concordance_pagination(loadedCorpusModel, concordanceModel, isSearchingOrFetching, numPages, dispatch), createElement("div", {
                    className: "level-right",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])]), createElement("nav", createObj(Helpers_combineClasses("level", props_25)))));
            }));
        }));
    }))));
}

export const ResultsView_GeoDistrMap_geoMapColors = ofArray(["yellow", "green", "blue", "purple", "black", "white", "red", "orange"]);

export function ResultsView_GeoDistrMap_GeoDistributionMap(resultsView_GeoDistrMap_GeoDistributionMapInputProps) {
    return null;
}

export function ResultsView_GeoDistrMap_GeoMapController(resultsView_GeoDistrMap_GeoMapControllerInputProps) {
    let elems_1, children, props_5, elems, children_2;
    const coordMap = resultsView_GeoDistrMap_GeoMapControllerInputProps.coordMap;
    const geoMapConfig = resultsView_GeoDistrMap_GeoMapControllerInputProps.geoMapConfig;
    const allCoords = resultsView_GeoDistrMap_GeoMapControllerInputProps.allCoords;
    const patternInput = useFeliz_React__React_useState_Static_1505("yellow");
    const selectedColor = patternInput[0];
    const patternInput_1 = useFeliz_React__React_useState_Static_1505(empty_2());
    const coloredPhons = patternInput_1[0];
    const locationNames = Array_distinct(toArray_1(collect(FSharpMap__get_Keys, FSharpMap__get_Values(coordMap))), {
        Equals: (x_5, y_5) => (x_5 === y_5),
        GetHashCode: stringHash,
    });
    const locationPhonFreqs = ofArray_1(map_1((tupledArg_4) => [tupledArg_4[0], ofArray_1(toArray_1(delay(() => collect((matchValue) => singleton([matchValue[1], matchValue[2]]), tupledArg_4[1]))))], Array_groupBy((tupledArg_3) => tupledArg_3[0], collect_1((tupledArg_1) => map_1((tupledArg_2) => [tupledArg_2[0], tupledArg_1[0], tupledArg_2[1]], toArray_2(tupledArg_1[1])), toArray_2(coordMap)), {
        Equals: (x_6, y_6) => (x_6 === y_6),
        GetHashCode: stringHash,
    })));
    const allCoordsMap = ofArray_1(map_1((tupledArg_5) => [tupledArg_5[0], [tupledArg_5[1], tupledArg_5[2]]], allCoords));
    const unknownLocations = toArray_1(delay(() => collect((locationName_1) => ((FSharpMap__TryFind(allCoordsMap, locationName_1) == null) ? singleton(locationName_1) : empty()), locationNames)));
    if (unknownLocations.length > 0) {
        const msg = join("\n", ["UNKNOWN LOCATIONS:", join("\n", unknownLocations), `Number of unknown locations: ${unknownLocations.length}`]);
        console.warn(some(msg));
    }
    const coords = toArray_1(delay(() => collect((locationName_2) => ((FSharpMap__TryFind(allCoordsMap, locationName_2) != null) ? singleton({
        Coords: FSharpMap__get_Item(allCoordsMap, locationName_2),
        Name: locationName_2,
        Phons: join("; ", map_1((tupledArg_6) => (`${tupledArg_6[0]}: ${tupledArg_6[1]}`), toArray_2(FSharpMap__get_Item(locationPhonFreqs, locationName_2)))),
    }) : empty()), locationNames)));
    const smallDots = toArray_1(delay(() => map((coord) => ({
        icon: "",
        key: coord.Name,
        label: `${coord.Name}: ${coord.Phons}`,
        latitude: coord.Coords[0],
        longitude: coord.Coords[1],
        name: coord.Name,
    }), coords)));
    const points = Array_distinct(append_1(smallDots, toArray_1(delay(() => collect((matchValue_1) => {
        const color_7 = matchValue_1[0];
        return toArray_1(delay(() => collect((phon_4) => {
            const selectedLocations = ofSeq(FSharpMap__get_Keys(FSharpMap__get_Item(coordMap, phon_4)), {
                Compare: comparePrimitives,
            });
            const selectedCoords = smallDots.filter((dot) => FSharpSet__Contains(selectedLocations, dot.name));
            return toArray_1(delay(() => map((coordMap_1) => {
                const key_14 = `${coordMap_1.key}_${color_7}`;
                return {
                    icon: `speech/mm_20_${color_7}.png`,
                    key: key_14,
                    label: coordMap_1.label,
                    latitude: coordMap_1.latitude,
                    longitude: coordMap_1.longitude,
                    name: coordMap_1.name,
                };
            }, selectedCoords)));
        }, matchValue_1[1])));
    }, toArray_2(coloredPhons))))), {
        Equals: equals,
        GetHashCode: structuralHash,
    });
    return createElement("div", createObj(ofArray([["className", "geo-map"], (elems_1 = [(children = toList(delay(() => map((color_8) => {
        let properties;
        const color = color_8;
        const props = ofArray([["className", "colorpicker"], (properties = ofArray([["backgroundColor", color], ["borderColor", contains(color, ofArray(["white", "red", "orange", "yellow"]), {
            Equals: (x, y) => (x === y),
            GetHashCode: stringHash,
        }) ? "black" : "red"], ["borderWidth", (selectedColor === color) ? 4 : 1]]), ["style", createObj(properties)]), ["onClick", (_arg1) => {
            patternInput[1](color);
        }]]);
        return createElement("button", createObj(Helpers_combineClasses("button", props)));
    }, ResultsView_GeoDistrMap_geoMapColors))), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    })), (props_5 = ofArray([["style", {
        marginTop: 10,
    }], (elems = toList(delay(() => map((phon_5) => {
        let properties_2;
        const phon = phon_5;
        const maybeColor = tryFindKey((_arg2, v) => contains_1(phon, v), coloredPhons);
        let colorStyles;
        if (maybeColor == null) {
            colorStyles = empty_1();
        }
        else {
            const color_3 = maybeColor;
            colorStyles = ofArray([["color", contains(color_3, ofArray(["green", "blue", "purple", "black", "red"]), {
                Equals: (x_1, y_1) => (x_1 === y_1),
                GetHashCode: stringHash,
            }) ? "white" : "dark"], ["backgroundColor", color_3]]);
        }
        const total = sumBy((tuple) => tuple[1], toArray_2(FSharpMap__get_Item(coordMap, phon)), {
            GetZero: () => fromInt(0),
            Add: op_Addition,
        });
        let titleText;
        const s = join("; ", map_1((tupledArg) => (`${tupledArg[0]}: ${tupledArg[1]}`), reverse(sortBy((tuple_1) => tuple_1[1], toArray_2(FSharpMap__get_Item(coordMap, phon)), {
            Compare: compare,
        }))));
        titleText = (`${s}; Total: ${total}`);
        const props_2 = ofArray([(properties_2 = append_2(colorStyles, singleton_1(["padding", 5])), ["style", createObj(properties_2)]), ["title", titleText], ["children", phon], ["onClick", (_arg3) => {
            const newMap = (maybeColor == null) ? coloredPhons : FSharpMap__Change(coloredPhons, maybeColor, (maybePhons) => ((maybePhons == null) ? (void 0) : FSharpSet__Remove(maybePhons, phon)));
            patternInput_1[1](((maybeColor == null) ? true : (value_190(maybeColor) !== selectedColor)) ? FSharpMap__Change(newMap, selectedColor, (maybePhons_1) => ((maybePhons_1 == null) ? singleton_2(phon, {
                Compare: comparePrimitives,
            }) : FSharpSet__Add(maybePhons_1, phon))) : newMap);
        }]]);
        return createElement("button", createObj(Helpers_combineClasses("button", props_2)));
    }, FSharpMap__get_Keys(coordMap)))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]), createElement("div", createObj(Helpers_combineClasses("buttons", props_5)))), (children_2 = singleton_1(createElement(result_map, {
        initLat: geoMapConfig.CenterLat,
        initLng: geoMapConfig.CenterLng,
        initZoom: geoMapConfig.ZoomLevel,
        width: 640,
        height: 460,
        points: points,
    })), createElement("div", {
        children: Interop_reactApi.Children.toArray(Array.from(children_2)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ResultsView_FrequencyLists_view(frequencyListsModel, corpus, dispatch) {
    let elems_1, elems_6, props_10, properties_9, elems_3, children_5, elms, props_12, elems_10, props_19, properties_16, elems_7, children_10, elms_1, props_21, props_27, props_29, props_31, elms_5, elms_2, props_36, elms_4, elm_11, elms_8, props_43, elm_7, elms_7, matchValue_6, frequencyRows, props_66, elems_29, elms_9, children_40, children_38, children_44;
    let caseSensitiveCheckbox;
    const children = singleton_1(createElement("label", createObj(ofArray([["style", {
        marginRight: 15,
    }], (elems_1 = [createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", frequencyListsModel.IsCaseSensitive], ["onChange", (ev_1) => {
        const _arg2 = ev_1.target.checked;
        dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(1));
    }]]))))), createElement("span", {
        className: "",
        children: " Case sensitive",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))));
    caseSensitiveCheckbox = createElement("p", {
        className: "field",
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let fromTokenInput;
    const value_32 = defaultArg(map_2(int32ToString, frequencyListsModel.TokenBoundaries.From), "");
    const props_16 = ofArray([["className", "is-horizontal"], (elems_6 = [(props_10 = ofArray([["className", "is-normal"], (properties_9 = singleton_1(["marginRight", 0.5 + "em"]), ["style", createObj(properties_9)]), (elems_3 = [createElement("label", {
        children: Interop_reactApi.Children.toArray(["From token:"]),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]), createElement("div", createObj(Helpers_combineClasses("field-label", props_10)))), (children_5 = singleton_1((elms = singleton_1((props_12 = ofArray([["style", {
        width: 60,
    }], ["value", value_32], ["onChange", (ev_2) => {
        const v = ev_2.target.value;
        if (v === "") {
            dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(2, void 0));
        }
        else {
            let matchValue;
            let outArg = 0;
            matchValue = [tryParse(v, 511, false, 32, new FSharpRef(() => outArg, (v_1) => {
                outArg = (v_1 | 0);
            })), outArg];
            if (matchValue[0]) {
                dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(2, matchValue[1]));
            }
        }
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props_12)))))), createElement("div", {
        className: "control",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    }))), createElement("div", {
        className: "field",
        children: Interop_reactApi.Children.toArray(Array.from(children_5)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])]);
    fromTokenInput = createElement("div", createObj(Helpers_combineClasses("field", props_16)));
    let toTokenInput;
    const value_60 = defaultArg(map_2(int32ToString, frequencyListsModel.TokenBoundaries.To), "");
    const props_25 = ofArray([["className", "is-horizontal"], (elems_10 = [(props_19 = ofArray([["className", "is-normal"], (properties_16 = singleton_1(["marginRight", 0.5 + "em"]), ["style", createObj(properties_16)]), (elems_7 = [createElement("label", {
        children: Interop_reactApi.Children.toArray(["To token:"]),
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])]), createElement("div", createObj(Helpers_combineClasses("field-label", props_19)))), (children_10 = singleton_1((elms_1 = singleton_1((props_21 = ofArray([["style", {
        width: 60,
    }], ["value", value_60], ["onChange", (ev_3) => {
        const v_3 = ev_3.target.value;
        if (v_3 === "") {
            dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(3, void 0));
        }
        else {
            let matchValue_1;
            let outArg_1 = 0;
            matchValue_1 = [tryParse(v_3, 511, false, 32, new FSharpRef(() => outArg_1, (v_4) => {
                outArg_1 = (v_4 | 0);
            })), outArg_1];
            if (matchValue_1[0]) {
                dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(3, matchValue_1[1]));
            }
        }
    }]]), createElement("input", createObj(cons(["type", "text"], Helpers_combineClasses("input", props_21)))))), createElement("div", {
        className: "control",
        children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
    }))), createElement("div", {
        className: "field",
        children: Interop_reactApi.Children.toArray(Array.from(children_10)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])]);
    toTokenInput = createElement("div", createObj(Helpers_combineClasses("field", props_25)));
    let buttonRow;
    const buttons = ofArray([(props_27 = toList(delay(() => append(singleton(["onClick", (_arg3) => {
        dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(6, new DownloadFormat(1)));
    }]), delay(() => {
        let matchValue_2;
        return append((matchValue_2 = frequencyListsModel.DownloadingFormat, (matchValue_2 == null) ? ((empty())) : ((matchValue_2.tag === 1) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => singleton(["children", "Excel"])));
    })))), createElement("button", createObj(Helpers_combineClasses("button", props_27)))), (props_29 = toList(delay(() => append(singleton(["onClick", (_arg4) => {
        dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(6, new DownloadFormat(3)));
    }]), delay(() => {
        let matchValue_3;
        return append((matchValue_3 = frequencyListsModel.DownloadingFormat, (matchValue_3 == null) ? ((empty())) : ((matchValue_3.tag === 3) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => singleton(["children", "Tab-separated"])));
    })))), createElement("button", createObj(Helpers_combineClasses("button", props_29)))), (props_31 = toList(delay(() => append(singleton(["onClick", (_arg5) => {
        dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(6, new DownloadFormat(2)));
    }]), delay(() => {
        let matchValue_4;
        return append((matchValue_4 = frequencyListsModel.DownloadingFormat, (matchValue_4 == null) ? ((empty())) : ((matchValue_4.tag === 2) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => singleton(["children", "Comma-separated"])));
    })))), createElement("button", createObj(Helpers_combineClasses("button", props_31))))]);
    const elm_3 = [(elms_5 = ofArray([(elms_2 = singleton_1(createElement("button", createObj(Helpers_combineClasses("button", ofArray([["className", "is-success"], ["onClick", (_arg6) => {
        dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(4));
    }], ["children", "Update stats"]]))))), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_2)),
    })), (props_36 = ofArray([["style", {
        marginLeft: 20,
    }], ["children", "Download:"]]), createElement("div", createObj(Helpers_combineClasses("level-item", props_36)))), (elms_4 = singleton_1(createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(buttons)),
    })), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(elms_4)),
    }))]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_5)),
    }))];
    buttonRow = createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_3)),
    });
    let controls;
    const matchValue_5 = Corpus__get_SharedInfo(corpus).LanguageConfig;
    if (matchValue_5.tag === 1) {
        throw (new Error("NOT IMPLEMENTED"));
    }
    else {
        const maybeAttrs = matchValue_5.fields[0];
        if (maybeAttrs == null) {
            const children_36 = ofArray([(elm_11 = [(elms_8 = ofArray([createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray([caseSensitiveCheckbox]),
            }), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray([fromTokenInput]),
            }), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray([toTokenInput]),
            })]), createElement("div", {
                className: "level-left",
                children: Interop_reactApi.Children.toArray(Array.from(elms_8)),
            }))], createElement("nav", {
                className: "level",
                children: Interop_reactApi.Children.toArray(Array.from(elm_11)),
            })), buttonRow]);
            controls = createElement("span", {
                children: Interop_reactApi.Children.toArray(Array.from(children_36)),
            });
        }
        else {
            const attrs = maybeAttrs;
            const checkboxes = toList(delay(() => map((attr) => {
                let attribute, isChecked, elems, s;
                const elms_6 = singleton_1((attribute = attr, (isChecked = contains(attr, frequencyListsModel.Attributes, {
                    Equals: equals,
                    GetHashCode: safeHash,
                }), createElement("label", createObj(ofArray([["style", {
                    marginRight: 15,
                }], (elems = [createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", isChecked], ["onChange", (ev) => {
                    const _arg1 = ev.target.checked;
                    dispatch(new LoadedCorpus_ShowingResults_FrequencyLists_Msg(0, attribute));
                }]]))))), (s = (` ${attribute.Name}`), createElement("span", {
                    className: "",
                    children: s,
                }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))))));
                return createElement("div", {
                    className: "control",
                    children: Interop_reactApi.Children.toArray(Array.from(elms_6)),
                });
            }, cons(SharedCorpusInfo__GetDefaultAttribute(Corpus__get_SharedInfo(corpus)), attrs))));
            const children_26 = ofArray([(props_43 = ofArray([["className", "is-grouped"], ["className", "is-grouped-multiline"], ["children", Interop_reactApi.Children.toArray(Array.from(checkboxes))]]), createElement("div", createObj(Helpers_combineClasses("field", props_43)))), (elm_7 = [(elms_7 = ofArray([createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray([caseSensitiveCheckbox]),
            }), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray([fromTokenInput]),
            }), createElement("div", {
                className: "level-item",
                children: Interop_reactApi.Children.toArray([toTokenInput]),
            })]), createElement("div", {
                className: "level-left",
                children: Interop_reactApi.Children.toArray(Array.from(elms_7)),
            }))], createElement("nav", {
                className: "level",
                children: Interop_reactApi.Children.toArray(Array.from(elm_7)),
            })), buttonRow]);
            controls = createElement("span", {
                children: Interop_reactApi.Children.toArray(Array.from(children_26)),
            });
        }
    }
    const frequencyTable = spinnerOverlay(frequencyListsModel.IsFetchingFrequencyList, void 0, (matchValue_6 = frequencyListsModel.Frequencies, (matchValue_6 == null) ? singleton_1(null) : ((frequencyRows = matchValue_6, singleton_1((props_66 = ofArray([["style", {
        marginTop: 20,
    }], (elems_29 = [(elms_9 = ofArray([(children_40 = singleton_1((children_38 = toList(delay(() => append(singleton(createElement("th", {
        children: ["Count"],
    })), delay(() => toList(delay(() => map((attr_1) => createElement("th", {
        children: [attr_1.Name],
    }), frequencyListsModel.Attributes))))))), createElement("tr", {
        children: Interop_reactApi.Children.toArray(Array.from(children_38)),
    }))), createElement("thead", {
        children: Interop_reactApi.Children.toArray(Array.from(children_40)),
    })), (children_44 = toList(delay(() => map((row) => {
        const children_42 = toList(delay(() => append(singleton(createElement("td", {
            style: {
                textAlign: "right",
            },
            children: toString_1(row.Frequency),
        })), delay(() => toList(delay(() => map((attrValue) => createElement("td", {
            children: [attrValue],
        }), row.AttributeValues)))))));
        return createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children_42)),
        });
    }, frequencyRows))), createElement("tbody", {
        children: Interop_reactApi.Children.toArray(Array.from(children_44)),
    }))]), createElement("table", {
        className: "table",
        children: Interop_reactApi.Children.toArray(Array.from(elms_9)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_29))])]), createElement("div", createObj(Helpers_combineClasses("table-container", props_66)))))))));
    return createElement("span", {
        children: Interop_reactApi.Children.toArray([controls, frequencyTable]),
    });
}

export function ResultsView_MetadataDistribution_view(corpus, model, dispatch) {
    let attrs, elems, elems_1, elems_2, elems_3, elms, props_13, props_15, props_17, elems_7, elms_1, children_6, value_105, value_106, elems_9, children_18, children_16, elm_3, elms_3, props_58, props_60;
    let attributes;
    const matchValue = Corpus__get_SharedInfo(corpus).LanguageConfig;
    if (matchValue.tag === 0) {
        attributes = ((matchValue.fields[0] == null) ? singleton_1(SharedCorpusInfo__GetDefaultAttribute(Corpus__get_SharedInfo(corpus))) : ((attrs = matchValue.fields[0], cons(SharedCorpusInfo__GetDefaultAttribute(Corpus__get_SharedInfo(corpus)), attrs))));
    }
    else {
        throw (new Error("NOT IMPLEMENTED"));
    }
    const attrOptions = toList(delay(() => map((attr) => createElement("option", {
        value: attr.Code,
        children: attr.Name,
    }), attributes)));
    let attrMenu;
    const patternInput = Helpers_extractClasses(ofArray([(elems = cons(createElement("option", {
        value: "",
        children: "Select attribute",
    }), attrOptions), ["children", Interop_reactApi.Children.toArray(Array.from(elems))]), ["onChange", (ev) => {
        const s = ev.target.value;
        if (s !== "") {
            dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(0, s));
        }
    }]]));
    attrMenu = createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput[0]))], (elems_1 = [createElement("select", createObj(patternInput[1]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])));
    let categoryOptions;
    const categories = isEmpty(Corpus__get_MetadataDistributionCategories(corpus)) ? Corpus__get_MetadataQuickView(corpus) : Corpus__get_MetadataDistributionCategories(corpus);
    categoryOptions = toList(delay(() => collect((matchValue_1) => singleton(createElement("option", {
        value: int32ToString(matchValue_1[0]),
        children: Metadata_Category__get_Name(matchValue_1[1]),
    })), indexed(categories))));
    let categoryMenu;
    const patternInput_1 = Helpers_extractClasses(ofArray([(elems_2 = cons(createElement("option", {
        value: "",
        children: "Select category",
    }), categoryOptions), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))]), ["onChange", (ev_1) => {
        const s_1 = ev_1.target.value;
        if (s_1 !== "") {
            dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(1, item(parse(s_1, 511, false, 32), Corpus__get_MetadataQuickView(corpus))));
        }
    }]]));
    categoryMenu = createElement("div", createObj(ofArray([["className", join(" ", cons("select", patternInput_1[0]))], (elems_3 = [createElement("select", createObj(patternInput_1[1]))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])));
    let keepZeroValueButton;
    const children = ofArray([createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", ofArray([["checked", model.KeepZeroValues], ["onChange", (ev_2) => {
        dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(2, ev_2.target.checked));
    }]]))))), " Show metadata values with zero total"]);
    keepZeroValueButton = createElement("label", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
    let downloadButtons;
    const children_3 = singleton_1((elms = ofArray([(props_13 = toList(delay(() => append(singleton(["onClick", (_arg1) => {
        dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(6, new DownloadFormat(1)));
    }]), delay(() => {
        let matchValue_2;
        return append((matchValue_2 = model.DownloadingFormat, (matchValue_2 == null) ? (((model.SelectedAttributeCode == null) ? true : (model.SelectedCategory == null)) ? singleton(["disabled", true]) : empty()) : ((matchValue_2.tag === 1) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => singleton(["children", "Excel"])));
    })))), createElement("button", createObj(Helpers_combineClasses("button", props_13)))), (props_15 = toList(delay(() => append(singleton(["onClick", (_arg2) => {
        dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(6, new DownloadFormat(3)));
    }]), delay(() => {
        let matchValue_3;
        return append((matchValue_3 = model.DownloadingFormat, (matchValue_3 == null) ? (((model.SelectedAttributeCode == null) ? true : (model.SelectedCategory == null)) ? singleton(["disabled", true]) : empty()) : ((matchValue_3.tag === 3) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => singleton(["children", "Tab-separated"])));
    })))), createElement("button", createObj(Helpers_combineClasses("button", props_15)))), (props_17 = toList(delay(() => append(singleton(["onClick", (_arg3) => {
        dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(6, new DownloadFormat(2)));
    }]), delay(() => {
        let matchValue_4;
        return append((matchValue_4 = model.DownloadingFormat, (matchValue_4 == null) ? (((model.SelectedAttributeCode == null) ? true : (model.SelectedCategory == null)) ? singleton(["disabled", true]) : empty()) : ((matchValue_4.tag === 2) ? singleton(["className", "is-loading"]) : singleton(["disabled", true]))), delay(() => singleton(["children", "Comma-separated"])));
    })))), createElement("button", createObj(Helpers_combineClasses("button", props_17))))]), createElement("div", {
        className: "buttons",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })));
    downloadButtons = createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    });
    let distributionTable;
    if (model.MetadataDistribution.Distribution.length > 0) {
        let removeSelectedRowsButton;
        const props_23 = ofArray([["className", "is-outlined"], ["className", "is-danger"], ["title", "Remove selected rows"], ["disabled", FSharpSet__get_IsEmpty(model.ExcludedAttributeValues.New)], ["onClick", (_arg4) => {
            dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(4));
        }], (elems_7 = [(elms_1 = singleton_1(createElement("i", {
            className: "fas fa-trash-alt",
        })), createElement("span", {
            className: "icon",
            children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])]);
        removeSelectedRowsButton = createElement("button", createObj(Helpers_combineClasses("button", props_23)));
        const categoryValueCells = toArray_1(delay(() => map((categoryValueStat) => {
            let elems_8;
            return createElement("th", createObj(ofArray([["key", categoryValueStat.Value], (elems_8 = [categoryValueStat.Value, createElement("br", {}), createElement("span", {
                style: {
                    fontWeight: "normal",
                },
                children: ` (${categoryValueStat.TokenCount} tokens)`,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])])));
        }, model.MetadataDistribution.CategoryValueStats)));
        const statsHeaderCells = [(children_6 = ofArray([createElement("span", {
            children: ["Total"],
        }), createElement("span", {
            style: {
                fontWeight: "normal",
            },
            children: ` (${model.MetadataDistribution.TotalTokenCount} tokens)`,
        })]), createElement("th", {
            children: Interop_reactApi.Children.toArray(Array.from(children_6)),
        })), createElement("th", {
            children: ["Deviation of proportions"],
        })];
        const frequencyRows = toArray_1(delay(() => map((attrValueDistribution) => {
            let children_8, props_32, children_10, value_99, value_100;
            const attrValue = attrValueDistribution.AttributeValue;
            const children_12 = concat([[(children_8 = singleton_1((props_32 = ofArray([["checked", FSharpSet__Contains(model.ExcludedAttributeValues.New, attrValue)], ["onChange", (ev_3) => {
                dispatch(new LoadedCorpus_ShowingResults_MetadataDistribution_Msg(3, attrValue, ev_3.target.checked));
            }]]), createElement("input", createObj(cons(["type", "checkbox"], Helpers_combineClasses("checkbox", props_32)))))), createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_8)),
            })), (children_10 = toList(delay(() => ((attrValue === "__UNDEF__") ? singleton(createElement("i", {
                children: ["Undefined"],
            })) : singleton(attrValue)))), createElement("td", {
                children: Interop_reactApi.Children.toArray(Array.from(children_10)),
            }))], toArray_1(delay(() => map((valueFreq) => {
                const value_98 = toString_1(valueFreq);
                return createElement("td", {
                    children: [value_98],
                });
            }, attrValueDistribution.MetadataValueFrequencies))), [(value_99 = toString_1(attrValueDistribution.AttributeValueTotal), createElement("td", {
                children: [value_99],
            })), (value_100 = toText(interpolate("%.2f%P()", [attrValueDistribution.Dp])), createElement("td", {
                children: [value_100],
            }))]]);
            return createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children_12)),
            });
        }, model.MetadataDistribution.Distribution)));
        let totalsFooter;
        const totalsCells = toArray_1(delay(() => map((stat) => {
            const value_101 = toString_1(stat.CategoryValueTotal);
            return createElement("th", {
                children: [value_101],
            });
        }, model.MetadataDistribution.CategoryValueStats)));
        const children_14 = concat([[createElement("th", {
            children: [""],
        }), createElement("th", {
            children: ["Total"],
        })], totalsCells, [(value_105 = toString_1(sumBy_1((categoryValue) => categoryValue.CategoryValueTotal, model.MetadataDistribution.CategoryValueStats, {
            GetZero: () => fromInt(0),
            Add: op_Addition,
        })), createElement("th", {
            children: [value_105],
        })), (value_106 = toText(interpolate("%.2f%P()", [model.MetadataDistribution.TotalDp])), createElement("th", {
            children: [value_106],
        }))]]);
        totalsFooter = createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children_14)),
        });
        let table;
        const props_53 = ofArray([["className", "metadata-distribution-table"], ["className", "is-bordered"], (elems_9 = [(children_18 = singleton_1((children_16 = concat([[createElement("th", {
            key: "remove-btn",
            children: removeSelectedRowsButton,
        }), createElement("th", {
            key: "attr-value",
            children: "",
        })], categoryValueCells, statsHeaderCells]), createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children_16)),
        }))), createElement("thead", {
            children: Interop_reactApi.Children.toArray(Array.from(children_18)),
        })), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(frequencyRows)),
        }), createElement("tfoot", {
            children: Interop_reactApi.Children.toArray([totalsFooter]),
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])]);
        table = createElement("table", createObj(Helpers_combineClasses("table", props_53)));
        distributionTable = createElement("div", {
            className: "table-container",
            children: Interop_reactApi.Children.toArray([table]),
        });
    }
    else {
        distributionTable = null;
    }
    const children_31 = ofArray([(elm_3 = [(elms_3 = ofArray([createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray([attrMenu]),
    }), createElement("div", {
        className: "level-item",
        children: Interop_reactApi.Children.toArray([categoryMenu]),
    }), (props_58 = ofArray([["style", {
        marginLeft: 5,
    }], ["children", Interop_reactApi.Children.toArray([keepZeroValueButton])]]), createElement("div", createObj(Helpers_combineClasses("level-item", props_58)))), (props_60 = ofArray([["style", {
        marginLeft: 20,
    }], ["children", "Download:"]]), createElement("div", createObj(Helpers_combineClasses("level-item", props_60)))), downloadButtons]), createElement("div", {
        className: "level-left",
        children: Interop_reactApi.Children.toArray(Array.from(elms_3)),
    }))], createElement("nav", {
        className: "level",
        children: Interop_reactApi.Children.toArray(Array.from(elm_3)),
    })), spinnerOverlay(model.IsFetching, void 0, singleton_1(distributionTable))]);
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_31)),
    });
}

export function ResultsView_tabs(loadedCorpusModel, showingResultsModel, dispatch) {
    let elems_4, children;
    let activeTab;
    const matchValue = showingResultsModel.ActiveTab;
    switch (matchValue.tag) {
        case 1: {
            activeTab = "GeoDistributionMap";
            break;
        }
        case 2: {
            activeTab = "Frequency lists";
            break;
        }
        case 3: {
            activeTab = "Metadata distribution";
            break;
        }
        default: {
            activeTab = "Concordance";
        }
    }
    const props_9 = ofArray([["style", {
        marginTop: 15,
    }], ["className", "is-toggle"], ["className", "is-toggle-rounded"], (elems_4 = [(children = toList(delay(() => append(singleton(createElement("li", createObj(toList(delay(() => append((activeTab === "Concordance") ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["onClick", (_arg1) => {
        dispatch(new LoadedCorpus_ShowingResults_Msg(3, new ResultTab(0)));
    }]), delay(() => {
        let elems;
        return singleton((elems = [createElement("a", {
            children: "Concordance",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]));
    }))))))))), delay(() => append((Corpus__get_SharedInfo(loadedCorpusModel.Corpus).GeoMapConfig != null) ? singleton(createElement("li", createObj(toList(delay(() => append((activeTab === "GeoDistributionMap") ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["onClick", (_arg2) => {
        dispatch(new LoadedCorpus_ShowingResults_Msg(3, new ResultTab(1, value_190(Corpus__get_SharedInfo(loadedCorpusModel.Corpus).GeoMapConfig), loadedCorpusModel.GeoDistribution)));
    }]), delay(() => {
        let elems_1;
        return singleton((elems_1 = [createElement("a", {
            children: "Map",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))]));
    }))))))))) : empty(), delay(() => append(singleton(createElement("li", createObj(toList(delay(() => append((activeTab === "Frequency lists") ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["onClick", (_arg3) => {
        dispatch(new LoadedCorpus_ShowingResults_Msg(3, new ResultTab(2, FrequencyListsModel_get_Default())));
    }]), delay(() => {
        let elems_2;
        return singleton((elems_2 = [createElement("a", {
            children: "Frequency lists",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))]));
    }))))))))), delay(() => ((!isEmpty(Corpus__get_MetadataQuickView(loadedCorpusModel.Corpus))) ? singleton(createElement("li", createObj(toList(delay(() => append((activeTab === "Metadata distribution") ? singleton(["className", "is-active"]) : empty(), delay(() => append(singleton(["onClick", (_arg4) => {
        dispatch(new LoadedCorpus_ShowingResults_Msg(3, new ResultTab(3, MetadataDistributionModel_Init())));
    }]), delay(() => {
        let elems_3;
        return singleton((elems_3 = [createElement("a", {
            children: "Metadata distribution",
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))]));
    }))))))))) : empty()))))))))), createElement("ul", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])]);
    return createElement("div", createObj(Helpers_combineClasses("tabs", props_9)));
}

export function ResultsView_view(loadedCorpusModel, showingResultsModel, corpus, search, topRowButtonsElement, loadedCorpusDispatch, dispatch) {
    const resultsView = toList(delay(() => {
        let elm, elms_1, elms;
        return append(singleton((elm = [(elms_1 = singleton_1((elms = singleton_1(ResultsView_tabs(loadedCorpusModel, showingResultsModel, dispatch)), createElement("div", {
            className: "level-item",
            children: Interop_reactApi.Children.toArray(Array.from(elms)),
        }))), createElement("div", {
            className: "level-left",
            children: Interop_reactApi.Children.toArray(Array.from(elms_1)),
        }))], createElement("nav", {
            className: "level",
            children: Interop_reactApi.Children.toArray(Array.from(elm)),
        }))), delay(() => {
            const matchValue = showingResultsModel.ActiveTab;
            switch (matchValue.tag) {
                case 1: {
                    const matchValue_1 = Corpus__get_SharedInfo(corpus).GeoCoordinates;
                    if (matchValue_1 == null) {
                        throw (new Error("No geographical coordinates provided!"));
                        return empty();
                    }
                    else {
                        const coords = matchValue_1;
                        return singleton(createElement(ResultsView_GeoDistrMap_GeoMapController, {
                            allCoords: coords,
                            geoMapConfig: matchValue.fields[0],
                            coordMap: matchValue.fields[1],
                        }));
                    }
                }
                case 2: {
                    return singleton(ResultsView_FrequencyLists_view(matchValue.fields[0], corpus, (arg_1) => {
                        dispatch(new LoadedCorpus_ShowingResults_Msg(1, arg_1));
                    }));
                }
                case 3: {
                    return singleton(ResultsView_MetadataDistribution_view(corpus, matchValue.fields[0], (arg_2) => {
                        dispatch(new LoadedCorpus_ShowingResults_Msg(2, arg_2));
                    }));
                }
                default: {
                    return ResultsView_Concordance_view(loadedCorpusModel, showingResultsModel.ConcordanceModel, corpus, loadedCorpusDispatch, (arg) => {
                        dispatch(new LoadedCorpus_ShowingResults_Msg(0, arg));
                    });
                }
            }
        }));
    }));
    const shouldShowResultsTableSpinner = (showingResultsModel.ActiveTab.tag === 0) && (showingResultsModel.ConcordanceModel.IsSearching && (showingResultsModel.ConcordanceModel.NumResults == null));
    const children_3 = ofArray([topRowButtonsElement, selectSearchView(corpus, search, loadedCorpusDispatch), spinnerOverlay(shouldShowResultsTableSpinner, singleton_1(["top", 75]), resultsView)]);
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_3)),
    });
}

export function view(model, dispatch) {
    let props_5, properties, elems_2, elms;
    const topRowButtonsElement = topRowButtons(model, dispatch);
    const children_1 = singleton_1((props_5 = ofArray([(properties = singleton_1(["paddingTop", 2.5 + "em"]), ["style", createObj(properties)]), ["tabIndex", 0], ["onClick", (_arg1) => {
        dispatch(new LoadedCorpus_Msg(23));
    }], ["onKeyUp", (e) => {
        if (e.key === "Escape") {
            dispatch(new LoadedCorpus_Msg(0, new Msg(1)));
        }
    }], (elems_2 = [(elms = toList(delay(() => {
        let props, elems;
        return append(shouldShowMetadataMenu(model) ? singleton((props = ofArray([["className", "is-narrow"], ["style", {
            marginRight: 20,
        }], (elems = [MetadataMenu_view(model, dispatch, (arg) => {
            dispatch(new LoadedCorpus_Msg(0, arg));
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]), createElement("div", createObj(Helpers_combineClasses("column", props))))) : empty(), delay(() => {
            let props_2, matchValue;
            return singleton((props_2 = ofArray([["style", {
                overflow: "auto",
            }], ["children", (matchValue = model.Substate, (matchValue.tag === 1) ? ResultsView_view(model, matchValue.fields[0], model.Corpus, model.Search, topRowButtonsElement, dispatch, (arg_1) => {
                dispatch(new LoadedCorpus_Msg(1, arg_1));
            }) : CorpusStartView_view(model.Corpus, model.Search, topRowButtonsElement, dispatch))]]), createElement("div", createObj(Helpers_combineClasses("column", props_2)))));
        }));
    })), createElement("div", {
        className: "columns",
        children: Interop_reactApi.Children.toArray(Array.from(elms)),
    })), createElement(MetadataQuickView, {
        model: model,
        dispatch: dispatch,
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]), createElement("section", createObj(Helpers_combineClasses("section", props_5)))));
    return createElement("span", {
        children: Interop_reactApi.Children.toArray(Array.from(children_1)),
    });
}

